import { IInstitutionDetails } from "../../organisations/model/InstitutionDetails";

const InstitutionDetailsParamMapper = (item: IInstitutionDetails) => {
  return {
    ...item
  };
};

export default InstitutionDetailsParamMapper;
